// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Numeral = require("../../../utils/Numeral.bs.js");
var Core__Int = require("@rescript/core/src/Core__Int.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");

function opt_of_string(value) {
  if (value !== "") {
    return value;
  }
  
}

function string_of_opt(value) {
  return Core__Option.getOr(value, "");
}

function stripNonDigits(s) {
  return s.replace(/\D/g, "");
}

function preventDefault(f, e) {
  e.preventDefault();
  return f();
}

function eventValue(evt) {
  return evt.target.value;
}

function addHttp(value) {
  var httpRegEx = /^(?:f|ht)tps?:\/\//;
  if (value === "") {
    return "";
  } else if (httpRegEx.test(value)) {
    return value;
  } else {
    return "https://" + value;
  }
}

function formatAsPhone(value) {
  var value$1 = value.replace(/\D/g, "");
  if (value$1.length === 0) {
    return "";
  }
  var first = value$1.substring(0, 3);
  var middle = value$1.substring(3, 6);
  var last = value$1.substring(6, 10);
  if (value$1.length > 6) {
    return "(" + first + ") " + middle + " - " + last;
  } else if (value$1.length > 3) {
    return "(" + first + ") " + middle;
  } else {
    return "(" + first;
  }
}

function intFromFormattedPrice($$event) {
  return Core__Int.fromString(stripNonDigits($$event.target.value), undefined);
}

function intOptToFormattedPrice(v) {
  return Core__Option.getOr(Core__Option.map(v, (function (v) {
                    return Numeral.format("FormPrice", v);
                  })), "");
}

function noneIfEmpty(str) {
  var match = Core__Option.map(str, (function (s) {
          return s.trim();
        }));
  if (match !== undefined && match !== "") {
    return str;
  }
  
}

function resultToStatus(s) {
  if (s !== undefined) {
    if (s.TAG === "Ok") {
      return "ok";
    } else {
      return "error";
    }
  }
  
}

function resultAsyncToStatus(s) {
  return Belt_Option.flatMap(s, (function (x) {
                if (x.TAG === "Validating") {
                  return ;
                } else if (x._0.TAG === "Ok") {
                  return "ok";
                } else {
                  return "error";
                }
              }));
}

exports.opt_of_string = opt_of_string;
exports.string_of_opt = string_of_opt;
exports.stripNonDigits = stripNonDigits;
exports.preventDefault = preventDefault;
exports.eventValue = eventValue;
exports.addHttp = addHttp;
exports.formatAsPhone = formatAsPhone;
exports.intFromFormattedPrice = intFromFormattedPrice;
exports.intOptToFormattedPrice = intOptToFormattedPrice;
exports.noneIfEmpty = noneIfEmpty;
exports.resultToStatus = resultToStatus;
exports.resultAsyncToStatus = resultAsyncToStatus;
/* Numeral Not a pure module */
